
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import moment from 'moment'

@Options({
  data() {
    return {
      viewConfig: {},
      list: [],
    }
  },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    mounted () {
        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        homeShareData.link = window.location.href
        this.$common.onshare(homeShareData)
        this.$common.track('load', '进入首页')
        this.renderView();
        this.getList();
    },
    methods: {
      renderView() {
        const { templateConfig } = this.activityData;
        this.viewConfig = {
          bg: templateConfig.backgroundImage || 'https://yunyingcdn.thecover.cn/o_1g1f5vko6sni7001au31qm13019.jpg',
          img: templateConfig.image,
          desc: templateConfig.desc,
        }
      },
      async getList() {
        const res = await this.$request('vote', {
          aid: this.aid,
          sort: 'votes'
        });
        const { list } = res; 
        this.list = list || [];
      },
      statusText(start, end) {
        const serverTime = moment(this.activityData.serverTime).unix();
        const startTime = moment(start).unix();
        const endTime = moment(end).unix();

        if (startTime > serverTime) {
          return (moment(start).month() + 1) + '月' + moment(start).date() + '日开始';
        }

        if (startTime <= serverTime && endTime >= serverTime) {
          return '进行中';
        }

        if (endTime < serverTime) {
          return '已结束';
        }
      },
      handleSkip(link, text) {
        if (text === '进行中') {
          window.location.href = link;
        }
      }
    },
})
export default class Home extends Vue {}
